// Self-contained translations for the PUBLIC finder/scan page (/t/:code).
// Auto-detects the finder's browser language. Supported: de, en, fr, it, es, tr. Fallback: en.
// This is independent of the app's own language (sb_lang) and never changes the owner's profile language.

const finderTranslations = {
  de: {
    locationError: "Standort konnte nicht ermittelt werden",
    locationAttached: "Standort hinzugefügt ✓",
    messageSent: "Danke! Deine Nachricht wurde übermittelt.",
    tagBlocked: "Dieser SafeBuddy wurde gesperrt.",
    deactivatedNotice: "Dieser SafeBuddy wurde deaktiviert.",
    notAvailable: "Diese SafeBuddy-Seite ist derzeit nicht verfügbar.",
    previewBanner: "Vorschaumodus – Scans werden nicht gezählt.",
    finderIntro: "Du hast einen SafeBuddy gefunden. Bitte hilf mit, die Person zu erreichen.",
    emergencyContacts: "Kontakte",
    callNow: "Jetzt anrufen",
    revealCall: "Nummer anzeigen & Anrufen",
    importantInfo: "Wichtige Hinweise",
    allergies: "Allergien",
    leaveMessage: "Nachricht hinterlassen",
    msgFormHint: "Teile dem Besitzer mit, wo du den Gegenstand gefunden hast und wie er dich erreichen kann.",
    yourName: "Dein Name (optional)",
    yourMessage: "Deine Nachricht",
    foundLocation: "Fundort (optional)",
    finderPhone: "Deine Telefonnummer (optional)",
    shareLocation: "Standort mitsenden",
    sendMessage: "Nachricht senden",
    poweredBy: "Bereitgestellt von SafeBuddy",
    statusCallable: "Buddy mit Anrufmöglichkeit",
    revealHint: "Nummer wird erst nach dem Tippen angezeigt.",
    locationConfirmed: "Standort wird mitgesendet",
    addToGroupLabel: "Tag zu Gruppe hinzufügen",
    locModalTitle: "Standort senden?",
    locModalText: "Dein aktueller Standort wird zusammen mit deiner Nachricht an den Besitzer übermittelt.",
    locModalHint: "Du kannst die Standortfreigabe jederzeit ablehnen.",
    cancel: "Abbrechen",
    locModalConfirm: "Standort senden",
    genericError: "Fehler",
  },
  en: {
    locationError: "Could not get your location",
    locationAttached: "Location attached ✓",
    messageSent: "Thank you! Your message has been sent.",
    tagBlocked: "This SafeBuddy has been blocked.",
    deactivatedNotice: "This SafeBuddy has been deactivated.",
    notAvailable: "This SafeBuddy page is currently unavailable.",
    previewBanner: "Preview mode – scans are not counted.",
    finderIntro: "You found a SafeBuddy. Please help reach this person.",
    emergencyContacts: "Contacts",
    callNow: "Call now",
    revealCall: "Reveal number & call",
    importantInfo: "Important notes",
    allergies: "Allergies",
    leaveMessage: "Leave a message",
    msgFormHint: "Optional: tell the owner where you found the item and how they can reach you.",
    yourName: "Your name (optional)",
    yourMessage: "Your message",
    foundLocation: "Found at (optional)",
    finderPhone: "Your phone number (optional)",
    shareLocation: "Share my location",
    sendMessage: "Send message",
    poweredBy: "Powered by SafeBuddy",
    statusCallable: "Buddy reachable by phone",
    revealHint: "The number is shown only after tapping.",
    locationConfirmed: "Location will be shared",
    addToGroupLabel: "Add tag to group",
    locModalTitle: "Share location?",
    locModalText: "Your current location will be sent to the owner together with your message.",
    locModalHint: "You can decline location sharing at any time.",
    cancel: "Cancel",
    locModalConfirm: "Share location",
    genericError: "Error",
  },
  fr: {
    locationError: "Impossible d'obtenir votre position",
    locationAttached: "Position ajoutée ✓",
    messageSent: "Merci ! Votre message a été envoyé.",
    tagBlocked: "Ce SafeBuddy a été bloqué.",
    deactivatedNotice: "Ce SafeBuddy a été désactivé.",
    notAvailable: "Cette page SafeBuddy est actuellement indisponible.",
    previewBanner: "Mode aperçu – les scans ne sont pas comptés.",
    finderIntro: "Vous avez trouvé un SafeBuddy. Aidez-nous à joindre cette personne.",
    emergencyContacts: "Contacts",
    callNow: "Appeler maintenant",
    revealCall: "Afficher le numéro et appeler",
    importantInfo: "Informations importantes",
    allergies: "Allergies",
    leaveMessage: "Laisser un message",
    msgFormHint: "Facultatif : indiquez au propriétaire où vous avez trouvé l'objet et comment vous joindre.",
    yourName: "Votre nom (facultatif)",
    yourMessage: "Votre message",
    foundLocation: "Lieu de découverte (facultatif)",
    finderPhone: "Votre numéro de téléphone (facultatif)",
    shareLocation: "Partager ma position",
    sendMessage: "Envoyer le message",
    poweredBy: "Propulsé par SafeBuddy",
    genericError: "Erreur",
  },
  it: {
    locationError: "Impossibile ottenere la tua posizione",
    locationAttached: "Posizione allegata ✓",
    messageSent: "Grazie! Il tuo messaggio è stato inviato.",
    tagBlocked: "Questo SafeBuddy è stato bloccato.",
    deactivatedNotice: "Questo SafeBuddy è stato disattivato.",
    notAvailable: "Questa pagina SafeBuddy non è attualmente disponibile.",
    previewBanner: "Modalità anteprima – le scansioni non vengono conteggiate.",
    finderIntro: "Hai trovato un SafeBuddy. Aiutaci a contattare questa persona.",
    emergencyContacts: "Contatti",
    callNow: "Chiama ora",
    revealCall: "Mostra numero e chiama",
    importantInfo: "Note importanti",
    allergies: "Allergie",
    leaveMessage: "Lascia un messaggio",
    msgFormHint: "Facoltativo: indica al proprietario dove hai trovato l'oggetto e come può contattarti.",
    yourName: "Il tuo nome (facoltativo)",
    yourMessage: "Il tuo messaggio",
    foundLocation: "Luogo del ritrovamento (facoltativo)",
    finderPhone: "Il tuo numero di telefono (facoltativo)",
    shareLocation: "Condividi la mia posizione",
    sendMessage: "Invia messaggio",
    poweredBy: "Offerto da SafeBuddy",
    genericError: "Errore",
  },
  es: {
    locationError: "No se pudo obtener tu ubicación",
    locationAttached: "Ubicación adjuntada ✓",
    messageSent: "¡Gracias! Tu mensaje ha sido enviado.",
    tagBlocked: "Este SafeBuddy ha sido bloqueado.",
    deactivatedNotice: "Este SafeBuddy ha sido desactivado.",
    notAvailable: "Esta página de SafeBuddy no está disponible en este momento.",
    previewBanner: "Modo de vista previa: los escaneos no se cuentan.",
    finderIntro: "Has encontrado un SafeBuddy. Ayuda a contactar a esta persona.",
    emergencyContacts: "Contactos",
    callNow: "Llamar ahora",
    revealCall: "Mostrar número y llamar",
    importantInfo: "Notas importantes",
    allergies: "Alergias",
    leaveMessage: "Dejar un mensaje",
    msgFormHint: "Opcional: indica al propietario dónde encontraste el objeto y cómo puede contactarte.",
    yourName: "Tu nombre (opcional)",
    yourMessage: "Tu mensaje",
    foundLocation: "Lugar del hallazgo (opcional)",
    finderPhone: "Tu número de teléfono (opcional)",
    shareLocation: "Compartir mi ubicación",
    sendMessage: "Enviar mensaje",
    poweredBy: "Con la tecnología de SafeBuddy",
    genericError: "Error",
  },
  tr: {
    locationError: "Konumunuz alınamadı",
    locationAttached: "Konum eklendi ✓",
    messageSent: "Teşekkürler! Mesajınız gönderildi.",
    tagBlocked: "Bu SafeBuddy engellendi.",
    deactivatedNotice: "Bu SafeBuddy devre dışı bırakıldı.",
    notAvailable: "Bu SafeBuddy sayfası şu anda kullanılamıyor.",
    previewBanner: "Önizleme modu – taramalar sayılmaz.",
    finderIntro: "Bir SafeBuddy buldunuz. Lütfen bu kişiye ulaşmaya yardımcı olun.",
    emergencyContacts: "Kişiler",
    callNow: "Şimdi ara",
    revealCall: "Numarayı göster ve ara",
    importantInfo: "Önemli notlar",
    allergies: "Alerjiler",
    leaveMessage: "Mesaj bırak",
    msgFormHint: "İsteğe bağlı: sahibine eşyayı nerede bulduğunuzu ve size nasıl ulaşabileceğini yazın.",
    yourName: "Adınız (isteğe bağlı)",
    yourMessage: "Mesajınız",
    foundLocation: "Bulunduğu yer (isteğe bağlı)",
    finderPhone: "Telefon numaranız (isteğe bağlı)",
    shareLocation: "Konumumu paylaş",
    sendMessage: "Mesaj gönder",
    poweredBy: "SafeBuddy tarafından sağlanır",
    genericError: "Hata",
  },
};

const SUPPORTED = ["de", "en", "fr", "it", "es", "tr"];

export function detectFinderLang() {
  if (typeof navigator === "undefined") return "en";
  const langs = (navigator.languages && navigator.languages.length) ? navigator.languages : [navigator.language || "en"];
  for (const l of langs) {
    const code = (l || "").toLowerCase().split("-")[0];
    if (SUPPORTED.includes(code)) return code;
  }
  return "en";
}

export function getFinderT(lang) {
  const dict = finderTranslations[lang] || finderTranslations.en;
  return (k) => dict[k] || finderTranslations.en[k] || k;
}

export { finderTranslations };
